import http from "../app/httpService";

const apiEndpoint = process.env.REACT_APP_MARKET_DATA_API + "TradeNegotiationMetadata/";

export async function getTradeNegotiationMetadataFields() {
  const { data: fields } = await http.get(apiEndpoint);
  return fields;
}

export async function getTradeNegotiationMetadataField(fieldDefinitionId) {
  const { data: field } = await http.get(apiEndpoint + fieldDefinitionId);
  return field;
}

export async function getTradeNegotiationMetadataFieldsByMarket(marketId) {
  const { data: fields } = await http.get(apiEndpoint + "market/" + marketId);
  return fields;
}

export async function addTradeNegotiationMetadataField(field) {
  const { data: savedField } = await http.post(apiEndpoint, field);
  return savedField;
}

export async function updateTradeNegotiationMetadataField(field) {
  const { data: savedField } = await http.put(apiEndpoint, field);
  return savedField;
}

export async function deleteTradeNegotiationMetadataField(fieldDefinitionId, eventId) {
  return await http.delete(apiEndpoint + fieldDefinitionId + "?eventId=" + eventId);
}